<template>
    <div v-if="active">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "tab",
        props: {
            name: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            active: {
                type: Boolean,
                default: false,
            }
        },
    }
</script>

<style scoped>

</style>